import React from "react";
import useAxios from "axios-hooks";
import TextField from "../../../../Forms/TextField";
import Select from "react-select";
import { FixedSizeList as List } from "react-window";
import { Checkbox } from "@fluentui/react";
import { useFormikContext } from "formik";

const CustomMenuList = ({ children, ...props }) => {
  const height = 35;
  const itemCount = Array.isArray(children) ? children.length : 0;
  const totalHeight = Math.min(300, itemCount * height);

  if (!Array.isArray(children) || itemCount === 0) {
    return <div>{children}</div>;
  }

  return (
    <List height={totalHeight} itemCount={itemCount} itemSize={height} width="100%">
      {({ index, style }) => (
        <div
          style={{
            ...style,
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
            padding: "0 8px",
            boxSizing: "border-box",
          }}
          title={children[index]?.props?.children}
        >
          {children[index]}
        </div>
      )}
    </List>
  );
};

const selectStyles = {
  menuList: (base) => ({
    ...base,
    maxHeight: "300px",
    overflowY: "auto",
  }),
  container: (base) => ({
    ...base,
    width: "100%",
  }),
  control: (base) => ({
    ...base,
    border: "1px solid #aaaaaa",
  }),
};

const ProprietaryGeneralFields = () => {
  const { getFieldProps } = useFormikContext();
  const [{ data, loading }] = useAxios(
    "action-items/proprietary-general-action-types"
  );

  const actionTypeValue = Number(getFieldProps("proprietaryGeneralActionType").value);
  const isMinimumScoreEnabled = actionTypeValue === 18;

  return (
    <>
      <ProprietaryGeneralActionTypeField
        loading={loading}
        data={data}
      />
      <ProprietaryGeneralTopicField />
      <TextField
        label={`Number of the Action Type Required`}
        placeholder="Select an option"
        type="number"
        name="proprietaryGeneralAmount"
        required
      />
      {isMinimumScoreEnabled && (
        <MinimumScoreField />
      )}
    </>
  );
};

const ProprietaryGeneralActionTypeField = ({ data, loading }) => {
  const { getFieldProps, setFieldValue } = useFormikContext();
  const options =
    data &&
    data.map((proprietaryGeneralField) => ({
      value: proprietaryGeneralField.pointsID,
      label: proprietaryGeneralField.name,
    }));

  const currentValue = getFieldProps("proprietaryGeneralActionType").value;

  return (
    <div>
      <label className="ms-Label root-113" style={{ fontWeight: 600, padding: "5px 0" }}>
        Action Type <span style={{ color: "rgb(164, 38, 44)" }}>*</span>
      </label>
      <Select
        components={{ MenuList: CustomMenuList }}
        options={options || []}
        placeholder="Select an option"
        value={options?.find((option) => option.value === currentValue) || null}
        onChange={(option) => setFieldValue("proprietaryGeneralActionType", option?.value)}
        isSearchable
        isDisabled={loading}
        styles={selectStyles}
      />
    </div>
  );
};

const ProprietaryGeneralTopicField = () => {
  const { getFieldProps, setFieldValue } = useFormikContext();
  const [{ data, loading }] = useAxios("resources/topics/titles");

  const options =
    data &&
    data.map((proprietaryGeneralTopic) => ({
      value: proprietaryGeneralTopic.topicId,
      label: proprietaryGeneralTopic.topicName,
    }));

  const currentValue = getFieldProps("proprietaryGeneralTopicID").value;

  return (
    <div>
      <label className="ms-Label root-113" style={{ fontWeight: 600, padding: "5px 0" }}>
        Topic
      </label>
      <Select
        components={{ MenuList: CustomMenuList }}
        options={options || []}
        placeholder="Select an option"
        value={options?.find((option) => option.value === currentValue) || null}
        onChange={(option) => setFieldValue("proprietaryGeneralTopicID", option?.value)}
        isSearchable
        isDisabled={loading}
        styles={selectStyles}
      />
    </div>
  );
};

const MinimumScoreField = () => {
  const { getFieldProps, setFieldValue } = useFormikContext();
  const isChecked = !!getFieldProps("forceMinimumScore").value;

  return (
    <div>
      <Checkbox
        label="Force minimum score"
        checked={isChecked}
        onChange={(_, checked) => {
          setFieldValue("forceMinimumScore", checked);
          if (checked && !getFieldProps("minimumScore").value) {
            setFieldValue("minimumScore", 100);
          }
        }}
        styles={{ root: { padding: "5px 0" } }}
      />
      {isChecked && (
        <TextField
          label="Minimum Score (%)"
          placeholder="100"
          type="number"
          name="minimumScore"
          min={0}
          max={100}
          required
        />
      )}
    </div>
  );
};

export default ProprietaryGeneralFields;
